import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styles from './StepSidebar.scss';
import { getMergedClassNames } from '../../../utils/HTMLUtils';
import TooltipCaller from '../../TooltipManager/TooltipCaller';
import Favo from '../../Favo/Favo';

const rootClassName = styles.rootClassName;

class StepSidebar extends Component {
  isSelected = () => {
    return typeof this.props.selected === 'boolean' &&
      this.props.selected === true
      ? this.props.selected
      : false;
  };

  isDisabled = () => {
    return typeof this.props.disabled === 'boolean' &&
      this.props.disabled === true
      ? this.props.disabled
      : false;
  };

  getTooltipCallerProps = () => {
    return {
      className: getMergedClassNames([
        rootClassName + '-tooltip-caller',
        this.isSelected() ? rootClassName + '-selected' : '',
        this.isDisabled() ? rootClassName + '-disabled' : '',
      ]),
      text: this.props.name,
    };
  };

  getProps = () => {
    return {
      className: getMergedClassNames([
        rootClassName,
        typeof this.props.className === 'string' ? this.props.className : '',
        this.isSelected() ? rootClassName + '-selected' : '',
        this.isDisabled() ? rootClassName + '-disabled' : '',
      ]),
      disabled: this.isDisabled(),
      onClick:
        !this.isDisabled() && typeof this.props.onClick === 'function'
          ? this.props.onClick
          : null,
    };
  };

  getFavoProps = () => {
    return {
      className: getMergedClassNames([
        rootClassName + '-favo',
        typeof this.props.favoClassName === 'string'
          ? this.props.favoClassName
          : '',
      ]),
      color: this.props.color,
    };
  };

  getIconProps = () => {
    return {
      className: getMergedClassNames([
        rootClassName + '-icon',
        typeof this.props.iconClassName === 'string'
          ? this.props.iconClassName
          : '',
      ]),
      style: {
        color: this.props.contrastColor || '#fff',
      },
    };
  };

  getStepElement = () => {
    return (
      <div {...this.getProps()}>
        <Favo {...this.getFavoProps()} />
        {this.props.icon ? (
          <div {...this.getIconProps()}>{this.props.icon}</div>
        ) : null}
      </div>
    );
  };

  render() {
    if (
      typeof this.props.name === 'string' &&
      this.props.name.trim().length > 0
    ) {
      return (
        <TooltipCaller {...this.getTooltipCallerProps()}>
          {this.getStepElement()}
        </TooltipCaller>
      );
    }
    return this.getStepElement();
  }
}

StepSidebar.propTypes = {
  className: PropTypes.string,
  favoClassName: PropTypes.string,
  iconClassName: PropTypes.string,
  color: PropTypes.string.isRequired,
  contrastColor: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  icon: PropTypes.element.isRequired,
  name: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default StepSidebar;
